import React, { useState /*useEffect, useContext*/ } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Popover } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import { setClassNameInDefns } from '../../common/definitionHelper';
import { INFO_TEXT_TRACK_EMP_HIRING_STATISTICS } from '../../common/constants';

import AfitdBox from '../../common/elemental/AfitdBox';
import AfitdTypography from '../../common/elemental/AfitdTypography';

const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            paddingBottom: 4,
            display: 'flex',
        },
        infoIcon: { fontSize: 16, marginBottom: 3 },
        infoPopover: {
            padding: 10,
        },
    }));
};

const getDefns = params => {
    const {
        classes,
        // props,
        infoPopoverOpen,
        anchorEl,
        setAnchorEl,
    } = params;

    let defns = {
        infoIconButton: {
            size: 'small',
            onClick: evt => {
                setAnchorEl(evt.currentTarget);
            },
        },
        infoPopover: {
            open: infoPopoverOpen,
            anchorEl,
            onClose: () => {
                setAnchorEl(null);
            },
            anchorOrigin: {
                vertical: 'center',
                horizontal: 'center',
            },
        },
        infoContainer: {
            p: 1,
            minWidth: '30%',
            maxWidth: 300,
        },
        infoText: {
            variant: 'body2',
            value: INFO_TEXT_TRACK_EMP_HIRING_STATISTICS,
        },
    };
    setClassNameInDefns(defns, classes);

    return defns;
};

const DialogFieldLabelWithTrackStateInfo = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [anchorEl, setAnchorEl] = useState(null);
    const infoPopoverOpen = Boolean(anchorEl);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { label, children, ...otherProps } = props;

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, infoPopoverOpen, anchorEl, setAnchorEl });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <AfitdBox {...defns.root}>
            <AfitdTypography variant="body2" clsLightBold={true} {...otherProps}>
                {children}
            </AfitdTypography>
            <IconButton {...defns.infoIconButton}>
                <InfoIcon {...defns.infoIcon} />
            </IconButton>
            <Popover {...defns.infoPopover}>
                <AfitdBox {...defns.infoContainer}>
                    <AfitdTypography {...defns.infoText} />
                </AfitdBox>
            </Popover>
        </AfitdBox>
    );
};

export default DialogFieldLabelWithTrackStateInfo;
